import loadable from '@loadable/component';

export const AsyncTripBoardModal = loadable(
    () =>
        import(
            /* webpackChunkName: "tripboard-modal" */
            /* webpackPrefetch: true */
            './TripBoardModal'
        ),
    {ssr: false}
);

AsyncTripBoardModal.displayName = 'AsyncTripBoardModal';
